module.exports = __webpack_public_path__ + "static/media/sheep.f4f37a50.svg";